import IReport from './IReport';
import generateCSV from '../../services/CSVController';
import save from 'save-file';
import { denominatorToFull } from '../../utils/rawPrice';

export interface IVatReportItem {
    'Tax Name': string;
    'inclusion_type': string;
    "percentage": number;
    'gross_taxable_amount': number;
    'tax_collected': number;
    'net_taxable_amount': number;
}
type VATReport = IVatReportItem[] | undefined;

export default async function generateVatReport(vatReport: VATReport, reportObj: IReport,venueName:string) {
    if (vatReport !== undefined && vatReport.length > 0) {
        const arrayOfkeys = Object.keys(vatReport[0])
        const arrayOfHeaders = Object.keys(vatReport[0]).map(item=>{
            if(item === "serial_id"){
                return "Venue ID"
            }
            let keyWords =item.split('_');
            keyWords.forEach(((word,i)=>{
                keyWords[i] = keyWords[i].charAt(0).toUpperCase() + keyWords[i].slice(1);
            }))
            return keyWords.join(' ');
        });
        const mapStockReport = vatReport.map((vatObject: IVatReportItem) => {
            return {
                ...vatObject,
                'gross_taxable_amount': denominatorToFull(vatObject['gross_taxable_amount']),
                'net_taxable_amount': denominatorToFull(vatObject['net_taxable_amount']),
                'tax_collected': denominatorToFull(vatObject['tax_collected']),
            };
        });
        const csvString = generateCSV(mapStockReport, arrayOfkeys, arrayOfHeaders);
        save(csvString, `${venueName}-tax-report-from${reportObj.start_date_time}to${reportObj.end_date_time}.csv`)
        return; 
    }
}
